import { observer } from "mobx-react-lite";
import appBannerImage from "../../../assets/menu/app-banner-background.png";
import appBannerImageMobile from "../../../assets/menu/app-banner-background-mobile.png";
import { useState } from "react";
import { ContextProps } from "@menu/core/types";
import environment from "@menu-environment";
import { AnalyticsType, getAnalyticTags } from "@menu/core/lib";

const AppBanner = observer((props: ContextProps) => {
  const { context } = props;

  const { appOneLink, isMobile, config, dictionary } = context;
  const [showBanner, setShowBanner] = useState(!!appOneLink && config.showAppBanner);

  const imageToUse = isMobile ? appBannerImageMobile : appBannerImage;
  const appStoreLogo = environment.menu.appBanner?.appLogo;

  const getBannerAnalytics = (cta: string, target?: string) => {
    return getAnalyticTags({
      component_name: "my_dstvapp_web_banner",
      nav_item: AnalyticsType.topLevel,
      nav_text: "",
      target_page_url: target ?? "",
      section_name: "top_nav_bar",
      component_type: "cta",
      cta_text: cta
    });
  };

  const buttonAnalyticTags = getBannerAnalytics(dictionary.appBannerCTA, appOneLink);
  const closeAnalytics = getBannerAnalytics("close banner")

  if (!showBanner) {
    return;
  }

  return (
    <div className="app-banner">
      <div className="banner-wrapper">
        {/* TODO: get app banner images from Umbraco instead of assets */}
        <img className="background-image" src={imageToUse as any} alt="App Banner background" />

        <div className="banner-text">{dictionary.appBannerText}</div>

        <a className="banner-actions-container" href={appOneLink} {...buttonAnalyticTags}>
          <img className="app-logo" src={appStoreLogo} alt="MyDStv Logo" />

          <i className="icon icon-downloads" />

          <span>{dictionary.appBannerCTA}</span>
        </a>

        <i className="icon icon-close banner-close" onClick={() => setShowBanner(false)} {...closeAnalytics}/>
      </div>
    </div>
  );
});

export default AppBanner;
